import type {ContractsListDto} from './typedef';

export type ParseContracts = {
    activeContracts: ContractsListDto,
    pastContracts: ContractsListDto,
    remainingActiveCredits: number,
};

export const parseContracts = (data: ContractsListDto): ParseContracts => {
    const pastContracts = [] as ContractsListDto;
    let remainingActiveCredits = 0;

    const activeContracts = data.reduce<ContractsListDto>((acc, item) => {
        if (item.contractInfo.activeContract) {
            remainingActiveCredits += item.creditBalanceInfo.remainingCredits;
            return acc.concat(item);
        }
        pastContracts.push(item);
        return acc;
    }, []);

    return {
        pastContracts,
        activeContracts,
        remainingActiveCredits,
    };
};
